module.exports = __webpack_public_path__ + "img/FR11833.2301d413.png";